export default "__VITE_ASSET__yVfk76Dj__"